module.exports = "https://cdn2-fs.clearscore.com/flux/images/78d55dcdee9d7e87b982b34c3dae781b.jpg";